"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetryHandler = void 0;
class RetryHandler {
    static RETRIES = 6;
    static async Retry(fn) {
        let retries = this.RETRIES;
        let lastError;
        while (retries > 0) {
            retries--;
            try {
                return await fn();
            }
            catch (e) {
                lastError = e;
                if (retries > 0) {
                    await new Promise((resolve) => setTimeout(resolve, 5000));
                }
            }
        }
        throw lastError;
    }
}
exports.RetryHandler = RetryHandler;
//# sourceMappingURL=retryHandler.js.map